import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { formulariosService } from '../services/api'

export default function FormularioActualizarDatos() {
  const { ticketId } = useParams()
  const [ticket, setTicket] = useState(null)
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState(false)
  const [enviado, setEnviado] = useState(false)
  const [enviando, setEnviando] = useState(false)
  const [form, setForm] = useState({
    telefono: '',
    correoAlterno: '',
    correoAlterno2: '',
    correoAlterno3: '',
    rfc: '',
    razonSocial: '',
    direccionFacturacion: '',
    codigoPostal: '',
    regimenFiscalClave: '',
    usoCfdi: '',
    metodoPago: ''
  })

  useEffect(() => {
    formulariosService.obtenerTicket(ticketId)
      .then(r => setTicket(r.data))
      .catch(() => setError(true))
      .finally(() => setCargando(false))
  }, [ticketId])

  const enviar = async () => {
    setEnviando(true)
    try {
      await formulariosService.actualizarDatos(ticketId, form)
      setEnviado(true)
    } catch (err) {
      setError(true)
    } finally {
      setEnviando(false)
    }
  }

  const contenedorStyle = { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F1EFE8', padding: 20 }
  const cardStyle = { background: '#fff', borderRadius: 12, padding: 32, maxWidth: 480, width: '100%', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }

  if (cargando) {
    return <div style={contenedorStyle}><div>Cargando...</div></div>
  }

  if (error && !ticket) {
    return (
      <div style={contenedorStyle}>
        <div style={cardStyle}>
          <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 20, marginBottom: 12 }}>Enlace no válido</div>
          <div style={{ fontSize: 14, color: '#8A8A7A' }}>No pudimos encontrar tu solicitud. Por favor contacta directamente a atencion@districtcoolingarboleda.com.</div>
        </div>
      </div>
    )
  }

  if (enviado) {
    return (
      <div style={contenedorStyle}>
        <div style={cardStyle}>
          <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 20, marginBottom: 12 }}>¡Gracias!</div>
          <div style={{ fontSize: 14, color: '#8A8A7A' }}>Recibimos tu solicitud de actualización de datos. Nuestro equipo la revisará y confirmará los cambios antes de aplicarlos a tu cuenta.</div>
        </div>
      </div>
    )
  }

  return (
    <div style={contenedorStyle}>
      <div style={cardStyle}>
        <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 20, marginBottom: 4 }}>Actualizar mis datos</div>
        <div style={{ fontSize: 13, color: '#8A8A7A', marginBottom: 4 }}>
          {ticket?.locatario?.nombre} · {ticket?.locatario?.subscriptionExternalId}
        </div>
        <div style={{ fontSize: 12, color: '#8A8A7A', marginBottom: 20 }}>
          Solo llena los campos que necesites cambiar. Los que dejes vacíos no se modifican.
        </div>

        <div className="form-group">
          <label className="form-label">Teléfono</label>
          <input className="form-input" placeholder="10 dígitos" value={form.telefono} onChange={e => setForm({ ...form, telefono: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Correo 1</label>
          <input className="form-input" placeholder="correo@ejemplo.com" value={form.correoAlterno} onChange={e => setForm({ ...form, correoAlterno: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Correo 2 (opcional)</label>
          <input className="form-input" placeholder="correo@ejemplo.com" value={form.correoAlterno2} onChange={e => setForm({ ...form, correoAlterno2: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Correo 3 (opcional)</label>
          <input className="form-input" placeholder="correo@ejemplo.com" value={form.correoAlterno3} onChange={e => setForm({ ...form, correoAlterno3: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">RFC</label>
          <input className="form-input" value={form.rfc} onChange={e => setForm({ ...form, rfc: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Razón social</label>
          <input className="form-input" value={form.razonSocial} onChange={e => setForm({ ...form, razonSocial: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Dirección de facturación</label>
          <textarea className="form-input" style={{ height: 70, resize: 'none' }} value={form.direccionFacturacion} onChange={e => setForm({ ...form, direccionFacturacion: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Código postal fiscal</label>
          <input className="form-input" placeholder="Ej. 66220" value={form.codigoPostal} onChange={e => setForm({ ...form, codigoPostal: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Clave de régimen fiscal (SAT)</label>
          <input className="form-input" placeholder="Ej. 601, 612, 621..." value={form.regimenFiscalClave} onChange={e => setForm({ ...form, regimenFiscalClave: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Uso de CFDI</label>
          <input className="form-input" placeholder="Ej. G03" value={form.usoCfdi} onChange={e => setForm({ ...form, usoCfdi: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Método de pago</label>
          <input className="form-input" placeholder="Ej. PPD, PUE" value={form.metodoPago} onChange={e => setForm({ ...form, metodoPago: e.target.value })} />
        </div>

        <button className="btn btn-primary" style={{ width: '100%', marginTop: 8 }} onClick={enviar} disabled={enviando}>
          {enviando ? 'Enviando...' : 'Enviar solicitud'}
        </button>
        <div style={{ fontSize: 11, color: '#8A8A7A', marginTop: 12, textAlign: 'center' }}>
          Los cambios serán revisados y confirmados por nuestro equipo antes de aplicarse.
        </div>
      </div>
    </div>
  )
}
